import ProductListing from "@/components/ProductListing";

export default function Shop() {
  return <ProductListing title="Shop All" />;
}
